import { Fade, Grid, Slide, Snackbar, Typography } from '@mui/material';

function SlideTransition(props) {
	return <Slide {...props} direction="left" />;
}

function ToastBanner({ message, icon, open, isCompleted = false, onClose }) {
	return (
		<Snackbar
			open={open}
			anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
			TransitionComponent={SlideTransition}
			onClose={onClose}>
			<Grid
				sx={{
					display: 'flex',
					alignItems: 'center',
					borderRadius: '8px',
					padding: '10px 16px',
					minWidth: '300px',
					backgroundColor: 'white',
					boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
					flexDirection: 'row',
				}}>
				<Grid
					style={{
						display: 'flex',
						alignItems: 'center',
						marginRight: '8px',
						width: 40,
						height: 40,
						borderRadius: '8px',
						backgroundColor: '#28696D',
						color: '#fff',
						justifyContent: 'center',
					}}>
					{icon}
				</Grid>
				<Typography
					style={{
						flexGrow: 1,
						fontWeight: '500',
						fontSize: '14px',
						paddingRight: '10px',
					}}>
					{message}
				</Typography>
				{!isCompleted ? (
					<div style={{ display: 'flex', gap: '4px' }}>
						<div
							style={{
								width: 8,
								height: 8,
								backgroundColor: '#28696D',
								borderRadius: '50%',
								animation: 'bounce 1s infinite',
								animationDelay: '0ms',
							}}
						/>
						<div
							style={{
								width: 8,
								height: 8,
								backgroundColor: '#28696D',
								borderRadius: '50%',
								animation: 'bounce 1s infinite',
								animationDelay: '150ms',
							}}
						/>
						<div
							style={{
								width: 8,
								height: 8,
								backgroundColor: '#28696D',
								borderRadius: '50%',
								animation: 'bounce 1s infinite',
								animationDelay: '300ms',
							}}
						/>
					</div>
				) : (
					<svg
						className="w-6 h-6 text-teal-500 dark:text-teal-400"
						fill="none"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth="2"
						viewBox="0 0 24 24"
						width={'24px'}
						height={'24px'}
						stroke="currentColor">
						{' '}
						<path d="M5 13l4 4L19 7" />{' '}
					</svg>
				)}
			</Grid>
		</Snackbar>
	);
}

export default ToastBanner;
